isPriceIncreased